import { FilterDataTyped } from '@nexelem/filters';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { DrawerFiltersData } from '../components/TasksDrawerFilters';

type FiltersStore = {
  filters: FilterDataTyped<DrawerFiltersData>;
  isTreeViewEnabled: boolean;
  setFilters: (filters: FilterDataTyped<DrawerFiltersData>) => void;
  setTreeView: (isTreeViewEnabled: boolean) => void;
};

export const useFiltersStore = create(
  persist<FiltersStore>(
    (set) => {
      return {
        filters: {
          dueDate: { value: { from: '', to: '' }, isMultiple: false, path: 'dueDate' },
          taskName: { value: '', isMultiple: false, path: 'taskName' },
          taskTypes: { value: [], isMultiple: true, path: 'taskTypes' },
          showOrders: { value: false, isMultiple: false, path: 'showOrders' },
          queues: { value: [], isMultiple: true, path: 'queues' },
        },
        isTreeViewEnabled: false,
        setFilters: (filters: FilterDataTyped<DrawerFiltersData>) => set({ filters }),
        setTreeView: (isTreeViewEnabled: boolean) => set({ isTreeViewEnabled }),
      };
    },
    { name: 'todo-filters-storage' },
  ),
);
